import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2 className="sidebar-logo">Roameez Admin</h2>
      </div>

      <nav className="sidebar-nav">
        <Link to="/dashboard" className={`sidebar-link ${isActive('/dashboard')}`}>
          <span className="sidebar-icon">🏠</span>
          <span>Dashboard</span>
        </Link>

        <Link to="/trips" className={`sidebar-link ${isActive('/trips')}`}>
          <span className="sidebar-icon">✈️</span>
          <span>Trips</span>
        </Link>

        <Link to="/users" className={`sidebar-link ${isActive('/users')}`}>
          <span className="sidebar-icon">👥</span>
          <span>Users</span>
        </Link>

        <Link to="/support" className={`sidebar-link ${isActive('/support')}`}>
          <span className="sidebar-icon">💬</span>
          <span>Support</span>
        </Link>

        <Link to="/profile" className={`sidebar-link ${isActive('/profile')}`}>
          <span className="sidebar-icon">👤</span>
          <span>Profile</span>
        </Link>
      </nav>
    </div>
  );
};

export default Sidebar;
